
import makerjs from "makerjs";

function C39(model, zoom, Param, fixedParam) {
  //w,h,w1,w2
  console.log("Param==", Param[0].param);
  console.log("Param==", Param[1].param);
  console.log("Param==", Param);
  var plate = model.plate, markers = model.markers, myZoom = zoom * 1,
    W = Param[0].param, H = Param[1].param, W1 = Param[2].param, H1 = Param[3].param, R1 = Param[4].param, R2 = Param[5].param,
    //  plate = model.plate, markers = model.markers,
    markShift = fixedParam.markShift * 1, markShiftTwo = fixedParam.markShiftTwo * 1,
    markShiftThree = fixedParam.markShiftThree * 1, markShiftFour = fixedParam.markShiftFour * 1, markHolesOneD = fixedParam.markHolesOneD * 1,

    h = H * 1 * myZoom,
    r1 = R1 * 1 * myZoom,
    w = W * 1 * myZoom,
    h1 = H1 * 1 * myZoom,
    r2 = R2 * 1 * myZoom,
    w1 = W1 * 1 * myZoom,
    // rdh=(r1-h)*(Math.sqrt(2)/2),
    // rdw=(r1-w)*(Math.sqrt(2)/2),
   
    hd2=(h-h1)*(Math.sqrt(2)/2),
    hd1=h*(Math.sqrt(2)/2),
    wd2=(w-w1)*(Math.sqrt(2)/2),
    wd1=w*(Math.sqrt(2)/2),
    x0 = w - w1, x1 = 0, x2 = 0, x3 = w, y0 = 0, y1 = h - h1, y2 = h, y3 = 0, glassH = h, glassW = w;
    console.log("x0,y0,x1,y1,x2,y2,x3,y3,wd1,hd1,wd2,hd2==",x0,y0,x1,y1,x2,y2,x3,y3,wd1,hd1,wd2,hd2);
    if (h !== 0) {
      var TxtH = H;
    } if (r1 !== 0) {
      var TxtR1 = "R1=" + R1;
    }
    if (w !== 0) {
      var TxtW = W;
    }
    if (h1 !== 0) {
      var TxtH1 = H1;
    } if (r2 !== 0) {
      var TxtR2 = "R2=" + R2;
    }
    if (w1 !== 0) {
      var TxtW1 = W1;
    }



  var drawAbnormalShapeC39 = {
    paths: {
      "ArcLine": new makerjs.paths.Arc([x0, y0], [x1, y1], r2, false, false),
      "LeftLine": new makerjs.paths.Line([x1, y1], [x2, y2]),
      "RtArcLine": new makerjs.paths.Arc([x2, y2], [x3, y3], r1, false, true),
      "BottomLine": new makerjs.paths.Line([x3, y3], [x0, y0]),
    }
  };
  var drawAbnormalShapeC39MarkH = {
    paths: {
      "RightLine": new makerjs.paths.Line([0 - 5*markShift, 0], [0 - 5*markShift, y2]),
      "RightShortUpline": new makerjs.paths.Line([0, 0], [0 - 7 * markShift, 0]),
      "RightShortDnline": new makerjs.paths.Line([x2, y2], [x2 - 7 * markShift, y2]),
    }
  };
  var drawAbnormalShapeC39MarkH1 = {
    paths: {
      "RightLine": new makerjs.paths.Line([x1- markShift, y2], [x1- markShift, y1]),
      "RightShortUpline": new makerjs.paths.Line([x1, y1], [x1- 2 * markShift, y1]),
      "RightShortDnline": new makerjs.paths.Line([x2, y2], [x2 - 2 * markShift, y2]),
    }
  };
  var drawAbnormalShapeC39MarkW = {
    paths: {
      "BottomLine": new makerjs.paths.Line([0, 0- 5*markShift], [x3, 0- 5*markShift]),
      "BotmShortLfline": new makerjs.paths.Line([0, 0], [0, 0 - 7 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 7 * markShift]),
    }
  };
  var drawAbnormalShapeC39MarkW1 = {
    paths: {
      "BottomLine": new makerjs.paths.Line([x0, y0 - markShift], [x3, y3 - markShift]),
      "BotmShortLfline": new makerjs.paths.Line([x0, y0], [x0, y0 - 2 * markShift]),
      "BotmShortRTline": new makerjs.paths.Line([x3, y3], [x3, y3 - 2 * markShift]),
    }
  };
  var drawAbnormalShapeC39MarkR2 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([0, 0], [0+wd2, 0+hd2]),
    }
  };
  var drawAbnormalShapeC39MarkR1 = {
    paths: {
      "LeftLine": new makerjs.paths.Line([0+wd1-2 * markShift, 0+hd1-2* markShift], [0+wd1, 0+hd1]),
    }
  };
  makerjs.model.addCaption(drawAbnormalShapeC39MarkW, TxtW, [0, 0 - 7 * markShift], [x3, 0 - 7* markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC39MarkR1, TxtR1, [0+wd1-4*markShift, 0+hd1 - 3 * markShift], [0+wd1-2*markShift, 0+hd1 - 3 * markShift]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC39MarkH, TxtH, [0 - 7*markShift, 0], [x2 - 7*markShift, y2]);//宽度文字
  makerjs.model.addCaption(drawAbnormalShapeC39MarkW1, TxtW1, [x0, y0 - 2 * markShift], [x3, y3 - 2 * markShift]);//长度文字  
  makerjs.model.addCaption(drawAbnormalShapeC39MarkR2, TxtR2, [0- 3* markShift, 0-2 * markShift], [0-2 * markShift, 0-2 * markShift]);//长度文字
  makerjs.model.addCaption(drawAbnormalShapeC39MarkH1, TxtH1, [x1- 2*markShift, y1], [x2- 2*markShift, y2]);//宽度文字

  plate = {
    models: {
      drawAbnormalShapeC39: drawAbnormalShapeC39,
    }
  };
  markers = {
    models: {
      drawAbnormalShapeC39: drawAbnormalShapeC39,
      drawAbnormalShapeC39MarkR1: drawAbnormalShapeC39MarkR1,
      drawAbnormalShapeC39MarkH: drawAbnormalShapeC39MarkH,
      drawAbnormalShapeC39MarkW: drawAbnormalShapeC39MarkW,
      drawAbnormalShapeC39MarkR2: drawAbnormalShapeC39MarkR2,
      drawAbnormalShapeC39MarkH1: drawAbnormalShapeC39MarkH1,
      drawAbnormalShapeC39MarkW1: drawAbnormalShapeC39MarkW1
    }
  };

  /*****************************************************************************/
  //return { plate, markers, glassW, glassH }

  return { w, h, plate, markers }
};


export default C39;